export default __webpack_public_path__ + "static/media/Blooded Harness of the Greensward.f2c736dc.jpg";